/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetRandomCoursesNotEnrolledOptions, GetRandomCoursesNotEnrolledResponses } from '../../models/GetRandomCoursesNotEnrolled'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Random Courses Not Enrolled
 * {@link /courses/get-random-courses-not-enrolled}
 */
export function getRandomCoursesNotEnrolled<ThrowOnError extends boolean = true>(options: Options<GetRandomCoursesNotEnrolledOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetRandomCoursesNotEnrolledResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/courses/get-random-courses-not-enrolled', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetRandomCoursesNotEnrolledResponses, ThrowOnError>>
}
